import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the leader state domain
 */

const selectLeaderDomain = (state) =>
  state.get("controlPanelUserManagementLeader", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsDownloading = () =>
  createSelector(selectLeaderDomain, (state) => state.get("isDownloading"))
/**
 * Default selector used by Leader
 */

const makeSelectLeader = () =>
  createSelector(selectLeaderDomain, (substate) => substate.toJS())

export default makeSelectLeader
export { selectLeaderDomain }
